import React, { useContext } from 'react';

import GAPageTracker from './GAPageTracker';
import Hotjar from './Hotjar';
import Hubspot from './Hubspot';
import { ConsentContext } from './ConsentContext';

const TrackingScripts = () => {
  const { consentStatus } = useContext(ConsentContext);

  return (
    <>
      <GAPageTracker allowTracking={consentStatus.allow} />
      <Hotjar allowTracking={consentStatus.allow} />
      <Hubspot allowTracking={consentStatus.allow} />
    </>
  );
};

export default TrackingScripts;